import React, { useCallback } from 'react'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import Modal from 'core/elements/modal'
import { deleteApplication, listApplications } from '../../repositories/actions'
import useListAction from 'core/hooks/useListAction'

export default function DeleteApp({ rows: [items], onClose }) {
  const { update: deleteFn, updating: deletingItems, error } = useUpdateAction(deleteApplication)
  const { reload } = useListAction(listApplications)
  const handleDelete = useCallback(async () => {
    const { success } = await deleteFn(items)
    if (success) {
      reload(true)
      onClose(true)
    }
  }, [items])

  return (
    <Modal
      panel="dialog"
      title="Delete Application"
      onClose={onClose}
      open
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={deletingItems}>
            Cancel
          </Button>
          <Button onClick={handleDelete} loading={deletingItems}>
            Confirm
          </Button>
        </>
      }
    >
      <>
        <Text variant="body2">This will permanently delete {items?.headerName}</Text>
        {!!error && <ErrorMessage>{error?.message}</ErrorMessage>}
      </>
    </Modal>
  )
}
